import React, {useEffect, useState} from 'react';
import clientAPI from "../../service/ApiService";
import {Alert, Input} from 'antd';
import SubmitRow from "./SubmitRequestRow";
import Pagination from "../Common/Pagination";
import {getSubmitRequestsEndpoint} from "../../service/RoleService";

function SubmitRequestTable({refresh}) {

    const initialState = {
        page: 1,
        submitRequests: [],
        sizePerPage: 20,
        totalSize: 0,
        error: null,
        loading: false
    };
    const [state, setState] = useState(initialState);

    useEffect(() => {
        getSubmitRequests()
    }, [state.page, state.sizePerPage, refresh]);// eslint-disable-line react-hooks/exhaustive-deps

    const getSubmitRequests = (search=null) => {
        setState({
            ...state,
            error: null,
            loading: true,
        });

        let requestUrl = getSubmitRequestsEndpoint() +
            "?page=" + state.page +
            "&limit=" + state.sizePerPage +
            "&order=asc" +
            (search ? "&keyword=" + encodeURIComponent(search) : "");

        clientAPI.get(requestUrl)
            .then(response => {

                let submitRequests = response.data?.data;
                if(!submitRequests || Object.keys(submitRequests).length === 0 || submitRequests.length <= 0 ){
                    setState({...state,
                        submitRequests:[],
                        totalSize: 0,
                        page: state.page > 1 ? state.page-1 : state.page
                    });
                    return false
                }

                setState({
                    ...state,
                    error: null,
                    loading: false,
                    submitRequests: submitRequests,
                    totalSize: response.data.pagination.total
                })
            })
            .catch(error => {

                let msg = error?.response?.data?.statusCode?.msg
                setState({
                    ...state,
                    error: msg ?? null,
                    loading: false,
                    submitRequests: [],
                    totalSize: null
                })
            })
    }

    const goToPage = ((page) => {
        setState({
            ...state,
            page: page
        })
    });

    const { Search } = Input;
    const [timer, setTimer] = useState(null);

    const setSearch = (event) => {
        var searchText = event.target.value;

        if (timer != null) {
            clearTimeout(timer);
        }

        setTimer(
            setTimeout(() => {
                getSubmitRequests(searchText)
            }, 300)
        )
    }

    return (
        <div>
            {state.error && <Alert message={state.error} type="error" closable className="notification" />}
            <Search placeholder="Search submit request by id or name"
                    loading={state.loading}
                    onChange={(e) => setSearch(e)}
            />
            {state.submitRequests &&
            <div className={"table-wrapper ant-table"}>
                <table className="table">
                    <thead className={"ant-table-thead"}>
                    <tr>
                        <th scope="col" style={{ color:"black" }}>Id</th>
                        <th scope="col">Hotel</th>
                        <th scope="col">Created at</th>
                    </tr>
                    </thead>
                    <tbody className={"ant-table-tbody"}>
                    {state?.submitRequests?.map((submitRequest, index) =>
                        <SubmitRow key={index} submitRequest={submitRequest} />
                    )}
                    </tbody>
                </table>
                <Pagination
                    sizePerPage={state.sizePerPage}
                    totalSize={state.totalSize}
                    page={state.page}
                    goToPage={goToPage}
                />
            </div>
            }
        </div>
    )
}


export default SubmitRequestTable;